function navigation(slider) {
	let wrapper, dots, arrowLeft, arrowRight

	function markup(remove) {
		wrapperMarkup(remove)
		dotMarkup(remove)
		arrowMarkup(remove)
	}

	function removeElement(elment) {
		elment.parentNode.removeChild(elment)
	}
	function createDiv(className) {
		var div = document.createElement("div")
		var classNames = className.split(" ")
		classNames.forEach((name) => div.classList.add(name))
		return div
	}

	function arrowMarkup(remove) {
		if (remove) {
			removeElement(arrowLeft)
			removeElement(arrowRight)
			return
		}
		arrowLeft = createDiv("keenArrow keenArrow--prev")
		arrowLeftInner = createDiv("mask keenArrow__icon")
		arrowLeft.addEventListener("click", () => slider.prev())

		arrowRight = createDiv("keenArrow keenArrow--next")
		arrowRightInner = createDiv("mask keenArrow__icon")
		arrowRight.addEventListener("click", () => slider.next())

		wrapper.appendChild(arrowLeft).appendChild(arrowLeftInner)
		wrapper.appendChild(arrowRight).appendChild(arrowRightInner)
	}

	function wrapperMarkup(remove) {
		if (remove) {
			var parent = wrapper.parentNode
			while (wrapper.firstChild)
				parent.insertBefore(wrapper.firstChild, wrapper)
			removeElement(wrapper)
			return
		}
		wrapper = createDiv("navigation-wrapper")
		slider.container.parentNode.appendChild(wrapper)
		wrapper.appendChild(slider.container)
	}

	function dotMarkup(remove) {
		if (remove) {
			removeElement(dots)
			return
		}
		dots = createDiv("keenDots")
		slider.track.details.slides.forEach((_e, idx) => {
			var dot = createDiv("keenDot")
			dot.addEventListener("click", () => slider.moveToIdx(idx))
			dots.appendChild(dot)
		})
		wrapper.appendChild(dots)
	}

	function updateClasses() {
		var slide = slider.track.details.rel
		slide === 0
			? arrowLeft.classList.add("arrow--disabled")
			: arrowLeft.classList.remove("arrow--disabled")
		slide === slider.track.details.slides.length - 1
			? arrowRight.classList.add("arrow--disabled")
			: arrowRight.classList.remove("arrow--disabled")
		Array.from(dots.children).forEach(function (dot, idx) {
			idx === slide
				? dot.classList.add("dot--active")
				: dot.classList.remove("dot--active")
		})
	}

	slider.on("created", () => {
		markup()
		updateClasses()
	})
	slider.on("optionsChanged", () => {
		console.log(2)
		markup(true)
		markup()
		updateClasses()
	})
	slider.on("slideChanged", () => {
		updateClasses()
	})
	slider.on("destroyed", () => {
		markup(true)
	})
}

let headerH;
(function () {
	let spFlg = false;
	let afterFlg = false;
	if (window.innerWidth <= 768) {
		spFlg = true;
	} else {
		spFlg = false;
	}
	afterFlg = spFlg;
	//-----------------------------------------------------------------------------ナビの文字分割
	// nav 文字分裂、代入　js--text--target
	var elements = document.querySelectorAll('.js--text--target');

	elements.forEach(function (element) {
		// Get the text content of the element
		var textContent = element.textContent;

		// Split
		var characters = textContent.split('');

		// 代入
		var newContent = characters.map(function (char) {
			return '<span class="textEle" data-textElm="' + char + '"><span>' + char + '</span></span>';
		}).join('');

		element.innerHTML = newContent;
	});

	//-----------------------------------------------------------------------------resize
	let scrollY = 32;
	function resize() {
		const winW = window.innerWidth;
		const winH = document.documentElement.clientHeight;
		headerH = document.querySelector('.fixBox').clientHeight;
		if (winW < 768) {
			scrollY = 19;
			spFlg = true;
		} else {
			scrollY = 32;
			spFlg = false;
		}
		if (spFlg != afterFlg) {
			window.location.reload();
		}
	}

	window.addEventListener("resize", () => {
		resize();
	}, true);

	resize();


	//-----------------------------------------------------------------------------header Move to Fix.
	let timeline = gsap.timeline();
	let tl = gsap.timeline({
		defaults: {},
		scrollTrigger: {
			trigger: ".wrapper",
			start: "top top",
			end: "+=" + scrollY,
			//pc用 end: "+=32",
			//sp用 end: "+=20",
			scrub: 0
		}
	});
	tl.fromTo('.header', { y: 0 }, { y: -1 * scrollY, ease: Power0.easeNone, });



	//-----------------------------------------------------------------------------menu 選択
	const urlArray = [
		'collections',
		'collection',
		'letter',
		'secret-ms',
		'about',
	];

	let urlID = -1;
	const navElm = document.querySelectorAll('.navList > li');

	for (let n = 0; n < urlArray.length; n++) {
		const dir = urlArray[n];
		if (document.URL.match(dir)) {
			urlID = n;
			break;
		}
	}

	if (urlID != -1) {
		navElm[urlID].classList.add('selected')
	}

	//-----------------------------------------------------------------------------ページトップ
	document.querySelector('.pageTop').addEventListener('click', function (e) {
		gsap.to(window, 1, { scrollTo: 0, ease: Power4.easeInOut });
	});

	//menu open
	document.querySelector('.js--menuBtn--open').addEventListener('click', function (e) {
		document.body.classList.add('menu--open');
		e.preventDefault();
	});
	document.querySelector('.menuInner__menuBtn').addEventListener('click', function (e) {
		document.body.classList.remove('menu--open');
		e.preventDefault();
	});

	//------------------------------------------------------------------------------------------Fix Newsアニメーション
	setTimeout(() => {
		//dom上に配置した要素を複製
		const newsComment = document.querySelector('.headerNews__detail div');
		const newsBaseSize = window.innerWidth;
		const newsCopy = newsComment.innerHTML;
		const newsWidth = newsComment.querySelector('p').getBoundingClientRect().width;
		const newsNum = Math.ceil(newsBaseSize / newsWidth);
		for (let i = 0; i < newsNum * 2; i++) {
			newsComment.insertAdjacentHTML("beforeend", newsCopy);
		}
		gsap.fromTo(newsComment, newsWidth / 40, { x: 0 }, { repeat: -1, x: -1 * newsWidth, ease: Power0.easeNone });
		gsap.fromTo('.headerNewsBlock', 1, { y: -100 }, { y: 0, ease: Power4.easeOut });
	}, 500);
})();

// 越境用元々の通貨記号を消す
document.addEventListener('DOMContentLoaded', function () {
	var priceElements = document.querySelectorAll('.price-value');
	priceElements.forEach(function (el) {
		var formattedPrice = el.textContent;
		// 通貨記号を取り除く
		var priceWithoutCurrency = formattedPrice.replace(/^[^\d]+/, '');
		el.textContent = priceWithoutCurrency;
	});
});

// MainCollectionの文字スライダーアニメーション
document.addEventListener('DOMContentLoaded', function () {
	const sliders = document.querySelectorAll('.js--collection--inner');

	sliders.forEach(slider => {
		const sliderTarget = slider.querySelector('.js--collection--text');
		const originalContent = sliderTarget.innerHTML;
		const repeatCount = 50; // 50回複製

		// コンテンツを50回複製
		for (let i = 0; i < repeatCount; i++) {
			sliderTarget.innerHTML += originalContent;
		}
	});
});

document.addEventListener('DOMContentLoaded', function () {
	const inputField = document.getElementById('dokopoiPointField');

	// 「pt」を表示するためのspan要素を作成
	const pointLabel = document.createElement('span');
	pointLabel.id = 'pointLabel';
	pointLabel.textContent = 'pt';
	pointLabel.style.display = 'inline'; // デフォルトで表示

	// inputの直後に「pt」を追加
	inputField.parentNode.insertBefore(pointLabel, inputField.nextSibling);

	// inputにplaceholderを追加
	inputField.setAttribute('placeholder', 'ポイント入力');

	function updatePointLabelVisibility() {
		if (inputField.type === 'hidden') {
			pointLabel.style.display = 'none';
		} else {
			pointLabel.style.display = 'inline';
		}
	}

	// 初期状態をチェック
	updatePointLabelVisibility();

	// 定期的にtype属性をチェック
	setInterval(updatePointLabelVisibility, 500); // 500ミリ秒ごとにチェック
});

// メインビジュアルの一言コメントを自動スクロールするようにする
document.addEventListener('DOMContentLoaded', function() {
	const messageWrapper = document.querySelector('.partsSp .messageText__wrapper');
	const messageText = document.querySelector('.partsSp .messageText');
	const textContent = messageText.innerHTML;
  
	const scrollContent = document.createElement('div');
	scrollContent.className = 'scroll-content';
  
	let repeatedText = '';
	for (let i = 0; i < 50; i++) {
	  repeatedText += `<span class="emoji">${textContent}</span>`;
	}
  
	scrollContent.innerHTML = repeatedText;
	messageWrapper.innerHTML = '';
	messageWrapper.appendChild(scrollContent);
  });

  document.addEventListener('DOMContentLoaded', function() {
	const messageWrapper = document.querySelector('.partsPc .messageText__wrapper');
	const messageText = document.querySelector('.partsPc .messageText');
	const textContent = messageText.innerHTML;
  
	const scrollContent = document.createElement('div');
	scrollContent.className = 'scroll-content';
  
	let repeatedText = '';
	for (let i = 0; i < 50; i++) {
	  repeatedText += `<span class="emoji">${textContent}</span>`;
	}
  
	scrollContent.innerHTML = repeatedText;
	messageWrapper.innerHTML = '';
	messageWrapper.appendChild(scrollContent);
  });

  // .article-33配下のdata-textelmが空のものを非表示
  document.querySelectorAll('.article-33 [data-textelm]').forEach(function(element) {
    // data-textelm属性の値をトリムして空かどうかをチェック
    if (element.getAttribute('data-textelm').trim() === '') {
      // 空の場合はhiddenクラスを追加
      element.classList.add('hidden');
    }
  });

  document.querySelectorAll('.float-menu-tag [data-textelm]').forEach(function(element) {
    // data-textelm属性の値をトリムして空かどうかをチェック
    if (element.getAttribute('data-textelm').trim() === '') {
      // 空の場合はhiddenクラスを追加
      element.classList.add('hidden');
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
	// サムネイルのリストを取得
	var thumbnails = document.querySelectorAll('.PDThum');
	// 画像・動画のリストを取得
	var images = document.querySelectorAll('.PDImg');
  
	thumbnails.forEach(function(thumbnail, index) {
	  thumbnail.addEventListener('click', function() {
		// すべてのサムネイルから「selected」クラスを削除
		thumbnails.forEach(function(thumb) {
		  thumb.classList.remove('selected');
		});
  
		// クリックされたサムネイルに「selected」クラスを追加
		this.classList.add('selected');
  
		// 対応する画像または動画にスクロール
		var targetImage = images[index];
		if (targetImage) {
		  targetImage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
		}
	  });
	});
  });

//   ラッピングの制御（通常ギフトと母の日ラッピングを一緒に購入できない様にする）
 //  document.addEventListener("DOMContentLoaded", function() {
	// const giftWrappingCheckbox = document.querySelector('[name="attributes[gift-wrapping]"]');
	// const motherWrappingCheckbox = document.querySelector('[name="attributes[mother-wrapping]"]');
	// const giftBoxContent = document.querySelector('.giftBoxContent');
	// const checkoutButton = document.querySelector('.input__checkOutBtn');

	// function showAlertMessage() {
	//   let alertMessage = giftBoxContent.querySelector('.alert-message');
	//   if (!alertMessage) {
	// 	alertMessage = document.createElement('p');
	// 	alertMessage.className = 'alert-message';
	// 	alertMessage.style.color = 'red';
	// 	alertMessage.textContent = 'Gift Boxはどちらかしか選択できません';
	// 	giftBoxContent.appendChild(alertMessage);
	//   }
	// }

	// function removeAlertMessage() {
	//   const alertMessage = giftBoxContent.querySelector('.alert-message');
	//   if (alertMessage) {
	// 	giftBoxContent.removeChild(alertMessage);
	//   }
	// }

	// function updateButtonState() {
	//   if (giftWrappingCheckbox.checked && motherWrappingCheckbox.checked) {
	// 	checkoutButton.disabled = true;
	//   } else {
	// 	checkoutButton.disabled = false;
	//   }
	// }

 //    ラッピング複数の時制御
	// function handleCheckboxChange() {
	//   localStorage.setItem('gift-wrapping', giftWrappingCheckbox.checked);
	//   localStorage.setItem('mother-wrapping', motherWrappingCheckbox.checked);

	//   if (giftWrappingCheckbox.checked && motherWrappingCheckbox.checked) {
	// 	showAlertMessage();
	//   } else {
	// 	removeAlertMessage();
	//   }

	//   updateButtonState();
	// }

	// function updateCart(attributeName, attributeValue, productId, quantity) {
	//   const headers = new Headers({ 'Content-Type': 'application/json' });
	//   const request = {
	// 	method: 'POST',
	// 	headers: headers,
	// 	body: JSON.stringify({ updates: { [productId]: quantity }, attributes: { [attributeName]: attributeValue } })
	//   };
	//   fetch('/cart/update.js', request)
	// 	.then(response => response.json())
	// 	.then(data => {
	// 	  console.log('Cart updated:', data);
	// 	  handleCheckboxChange(); // Update alert and button state after cart update
	// 	})
	// 	.catch(error => console.error('Error updating cart:', error));
	// }

	// // Restore checkbox states from localStorage
	// giftWrappingCheckbox.checked = localStorage.getItem('gift-wrapping') === 'true';
	// motherWrappingCheckbox.checked = localStorage.getItem('mother-wrapping') === 'true';

	// // Initialize alert message and button state based on restored states
	// handleCheckboxChange();

	// giftWrappingCheckbox.addEventListener('change', function(event) {
	//   if (event.target.checked) {
	// 	updateCart('gift-wrapping', true, '45778849693922', 1);
	//   } else {
	// 	updateCart('gift-wrapping', '', '45778849693922', 0);
	//   }
	// });

	// motherWrappingCheckbox.addEventListener('change', function(event) {
	//   if (event.target.checked) {
	// 	updateCart('mother-wrapping', true, '46487839310050', 1);
	//   } else {
	// 	updateCart('mother-wrapping', '', '46487839310050', 0);
	//   }
	// });
 //  });
